import React from "react";

import "./index.scss";

export type TitleProps = React.PropsWithChildren;

export const Title: React.FC<TitleProps> = ({ children }) => {
  return <div className="progress-title">{children}</div>;
};
